import { createContext } from 'react';

const TableHeadContext = createContext({ variant: '' });

export default TableHeadContext;
